import React from "react";
import classNames from "classnames";

const PatientList = ({
  patients,
  selectedPatient,
  handlePatient,
  onCLickZoomToMarker,
  isModal = false,
}) => {
  return (
    <div className="flex flex-col w-full gap-2 pt-3 overflow-scroll rounded-b-sm no-scrollbar">
      {patients.map((patient, ind) => (
        <button
          key={ind}
          onClick={() => {
            if (isModal) {
              return;
            }

            handlePatient(ind);
            onCLickZoomToMarker(
              patient.coordinates.latitude,
              patient.coordinates.longitude
            );
          }}
          className={classNames(
            "w-full flex flex-col p-2 border rounded-md",
            isModal
              ? "bg-white text-black"
              : selectedPatient === ind
              ? isModal ? "bg-primaryblue text-white" : "bg-subtleblue text-black"
              : "bg-white text-black"
          )}
        >
          <p className="m-0 font-semibold text-left text-primaryblue">
            {!isModal ? "" : "Patient: "}
            <span className={isModal ? "font-normal" : "font-semibold"}>
              {patient.name}
            </span>
          </p>
          {!isModal && (
            <>
              <p className="m-0 font-semibold text-left">{patient.location}</p>
              <p className="m-0 text-left">{patient.address}</p>
            </>
          )}
          {isModal && (
            <p className="m-0 font-semibold text-left">
              Primary Provider:{" "}
              <span className="font-normal">{patient.provider}</span>
            </p>
          )}
        </button>
      ))}
    </div>
  );
};

export default PatientList;
